import { render, staticRenderFns } from "./BaseComboBox.vue?vue&type=template&id=2183e3f4&"
import script from "./BaseComboBox.js?vue&type=script&lang=js&"
export * from "./BaseComboBox.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports